import { FC, useEffect, useMemo, useState } from 'react';
import { Cascader, CascaderOption } from 'antd-mobile';
import {
  queryFloorList,
  queryUnitList,
  queryAllHouseList,
} from '@/pages/BindHouse/service';
import { CascaderValue } from 'antd-mobile/es/components/cascader-view';
import { floorType, roomType, unitType } from '@/pages/BindHouse/interface';

interface ISelectRoomProps {
  visible: boolean;
  communityInfo?: any;
  confirmSelect: (value: selectedDataType) => void;
  close: () => void;
}

export type selectedDataType = {
  label: string;
  floorId: string;
  unitId: string;
  roomId: string;
  ownerId: string;
};

const SelectRoom: FC<ISelectRoomProps> = (props) => {
  const { visible, communityInfo, confirmSelect, close } = props;
  const [valueToOptions, setValueToOptions] = useState<any>({});
  const [floorList, setFloorList] = useState<floorType[]>([]);
  const [floorId, setFloorId] = useState<string>();
  const [unitList, setUnitList] = useState<unitType[]>([]);
  const [houseList, setHouseList] = useState<roomType[]>([]);

  const options = useMemo<CascaderOption[]>(() => {
    function generate(v: string): CascaderOption[] | undefined {
      const options = valueToOptions[v];
      if (options === null) {
        return undefined;
      }
      if (options === undefined) {
        return Cascader.optionSkeleton;
      }
      return options.map((option: any) => ({
        ...option,
        children: generate(option.value as string),
      }));
    }
    return generate('') ?? [];
  }, [valueToOptions]);

  const fetchOptions = async (value: string, level: number) => {
    console.log(value, level, valueToOptions, 'options');

    if (value in valueToOptions) return;
    if (level >= 2) {
      setValueToOptions((prev: any) => ({
        ...prev,
        [value]: null,
      }));
      return;
    }
    if (value === '' && communityInfo?.communityId) {
      const floorData = await queryFloorList({
        communityId: communityInfo?.communityId,
      });
      const options = floorData?.data?.map((item: floorType) => ({
        label: item.name,
        value: item.id,
        ...item,
      }));
      setFloorList(floorData?.data || []);
      setValueToOptions((prev: any) => ({
        ...prev,
        [value]: options,
      }));
    } else if (value !== '' && level === 0) {
      setFloorId(value);
      queryUnitList({
        communityId: communityInfo?.communityId,
        floorId: value,
      }).then((res) => {
        const options = res?.data?.map((item: any) => ({
          label: `${item.unitNum}单元`,
          value: item.id,
          ...item,
        }));
        setUnitList(res?.data || []);
        setValueToOptions((prev: any) => ({
          ...prev,
          [value]: options,
        }));
      });
    } else if (value !== '' && level === 1) {
      const houseData = await queryAllHouseList({
        communityId: communityInfo?.communityId,
        unitId: value,
        floorId: floorId,
      });
      setHouseList(houseData?.data || []);
      setValueToOptions((prev: any) => ({
        ...prev,
        [value]: houseData?.data?.map((item: any) => ({
          label: item.roomNum,
          value: item.id,
          ...item,
        })),
      }));
    }
  };

  const handleConfirm = (value: CascaderValue[]) => {
    console.log(value, 'value');
    const floorId = value[0] as string;
    const unitId = value[1] as string;
    const roomId = value[2] as string;
    const floorInfo = floorList.find((item) => item.id === floorId);
    const unitInfo = unitList.find((item) => item.id === unitId);
    const roomInfo = houseList.find((item) => item.id === roomId);
    const selectedValue: selectedDataType = {
      label: `${floorInfo?.name}${unitInfo?.unitNum}单元${roomInfo?.roomNum}`,
      floorId: floorId,
      unitId: unitId,
      roomId: roomId,
      ownerId: roomInfo?.ownerId || '',
    };
    confirmSelect(selectedValue);
    close();
  };

  useEffect(() => {
    fetchOptions('', 0);
  }, []);

  return (
    <div>
      <Cascader
        visible={visible}
        options={options}
        title={'房间选择'}
        onClose={close}
        onConfirm={handleConfirm}
        onSelect={(value) => {
          value.forEach((item: any, index: number) => {
            fetchOptions(item, index);
          });
        }}
      />
    </div>
  );
};

export default SelectRoom;
